export enum OpacityValues {
    NO_OPACITY = 0,
    FULL_OPACITY = 1
}
